import React, { useEffect } from 'react';
import styles from './styles.module.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setFiltersVisibility } from '../../actions/index';
import { setShipmentFilterVisibility } from '../../../modules/delivery/shipments/actions';
import { Button } from '../../ui';

const FilterModal = ({
  common: { isFiltersOpen },
  shipment: { isShipmentFiltersOpen },
  setFiltersVisibility,
  setShipmentFilterVisibility,
  title = 'Filter by',
  children,
  onApply,
}) => {
  const open = isFiltersOpen || isShipmentFiltersOpen;

  const handleClose = () => {
    setFiltersVisibility(false);
    setShipmentFilterVisibility(false);
  };

  const handlePanelClick = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') handleClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open]);

  if (!open) return null;

  return (
    <div className={styles.root} role="dialog" aria-modal="true" aria-label={title}>
      <div
        className={styles.overlay}
        onClick={handleClose}
        aria-hidden="true"
      />
      <div className={styles.panel} onClick={handlePanelClick}>
        <div className={styles.upperDiv}>
          <div className={styles.titleDiv}>{title}</div>
          <div className={styles.filterOptionsDiv}>{children}</div>
        </div>
        <div className={styles.lowerDiv}>
          <Button type="button" className={styles.applyBtn} onClick={onApply}>
            Apply
          </Button>
          <Button type="button" variant="secondary" className={styles.cancelBtn} onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

FilterModal.propTypes = {
  common: PropTypes.shape({ isFiltersOpen: PropTypes.bool }).isRequired,
  shipment: PropTypes.shape({ isShipmentFiltersOpen: PropTypes.bool }),
  setFiltersVisibility: PropTypes.func,
  setShipmentFilterVisibility: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  onApply: PropTypes.func.isRequired,
};

FilterModal.defaultProps = {
  shipment: { isShipmentFiltersOpen: false },
  setFiltersVisibility: () => {},
  setShipmentFilterVisibility: () => {},
};

const mapStateToProps = (state) => ({
  common: state.commonState,
  shipment: state.shipmentsState || { isShipmentFiltersOpen: false },
});

export default connect(mapStateToProps, {
  setFiltersVisibility,
  setShipmentFilterVisibility,
})(FilterModal);
